// extracted by mini-css-extract-plugin
export default {"input-container":"styles_input-container__AxFKv","label":"styles_label__k035K"};